import RestAPI from '../../components/Common/restApi';

export default class WebsiteConfigurationApi {
  static show() {
    return RestAPI.get('/alpha/organization/website_content');
  }

  static update(content) {
    return RestAPI.updateWithFormData('/alpha/organization/website_content', content);
  }
}
